module.exports = __webpack_public_path__ + "static/media/back_button_v2.aa3b5234.png";